
/* injects from baggage-loader */

'use strict';

export default class PageTenController {
    constructor($state, $log, Dialog, Session) {
        'ngInject';   
        this.$state = $state;  
        this.$log = $log;   
        this.Dialog = Dialog;
        this.Session = Session;
    }

    $onInit(){
        this.embedded = require('_images/page-ten/feedback.png');
        this.final = require('_images/page-ten/caixa-final-da-revista.png');
    }

    $onDestroy(){
        this.resetStage();
    }

    resetStage() {        
        return false;
    }

    feedback(){
        this.Dialog.showEmbedded(this.embedded, 0, this.relerRevista.bind(this));
    }

    relerRevista(){
        this.Session.destroy();
        this.Dialog.showReler(this.final);
        //return false;
    }

    escrever() {
        this.Dialog.showLetterBox(this.feedback.bind(this));
    }

    redirectToStages(){
        this.$state.go("main");
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-ten/page-ten.controller.js